export const MFA_CTX_LOGIN = "login";
export const MFA_CTX_SETUP = "setup";
export const MFA_INVALID_CODE_PROVIDED = "The verification code is not valid. Please try again";
export const MFA_INVALID_PHONE_NUMBER_PROVIDED = "Invalid phone number provided";
export const MFA_EXPIRY_CODE_PROVIDED = "Verification code expired, please try again.";
export const MFA_LIMIT_EXCEED = "You have exceeded the number of verification attempts. Please try again in an hour.";